import React from 'react';
import * as Raven from 'raven-js';
import IconDashboard from './IconDashboard';
var ListTeamsItemStatusIcons = function (props) {
    if (!props.teamScore || !props.teamScore.statusIcons) {
        return null;
    }
    var statusIcons = [];
    try {
        statusIcons = typeof props.teamScore.statusIcons === 'string'
            ? JSON.parse(props.teamScore.statusIcons)
            : props.teamScore.statusIcons;
    }
    catch (err) {
        Raven.captureException(err);
    }
    return (React.createElement(React.Fragment, null, statusIcons.map(function (iconType) { return (React.createElement(IconDashboard, { key: iconType, type: iconType })); })));
};
export default ListTeamsItemStatusIcons;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListTeamsItemStatusIcons.tsx
// module id = 664
// module chunks = 0